import { Component, Prop, Vue } from 'vue-property-decorator'

import BadgePerson from '@/components/BadgePerson/index.vue'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
	faClock,
	faScroll,
	faFeatherPointed,
	faPrint,
	faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons'

library.add(faClock, faScroll, faFeatherPointed, faPrint, faTriangleExclamation)

@Component({
	components: {
		BadgePerson,
	},
})
export default class CardEmailLog extends Vue {
	@Prop() readonly emailLog

	getShortDate(date) {
		if (date && typeof date !== 'string') {
			date = date.toISOString()
		}

		let result = date?.split('T')[0]
		result = result?.split('-')?.reverse()

		if (result && result.pop) {
			result.pop()
			return result.join('/')
		}

		return null
	}

	getClass() {
		const nowString = new Date().toISOString().split('T')[0]
		const midDayUtcString = 'T12:00:00.000Z'
		const oneDayInMs = 86400000

		const sendAtStr = new Date(this.emailLog.send_at)
			.toISOString()
			.split('T')[0]

		const today = new Date(nowString + midDayUtcString)
		const sendAt = new Date(sendAtStr + midDayUtcString)

		let diffDays = oneDayInMs * 2 // dois dias de diferenca

		if (today.getTime() >= sendAt.getTime()) {
			return 'alert-danger'
		}

		// se for quinta ou sexta, somar os dois dias para pular o fds
		// exemplo: se a data de envio for segunda, dois dias antes seria o sabado
		// para pular o fds adicionamos mais 2 dias a diferenca
		if (today.getDay() === 4 || today.getDay() === 5) {
			diffDays = diffDays + oneDayInMs * 2
		}

		if (today.getTime() + diffDays >= sendAt.getTime()) {
			return 'alert-warning'
		}

		return 'alert-info'
	}

	parseStatus(status) {
		switch (status) {
			case 'nao_aprovado':
				return 'Não aprovado'
			case 'pendente':
				return 'Pendente'
			case 'aprovado':
				return 'Aprovado'
		}
	}

	getStatusColor(status) {
		switch (status) {
			case 'nao_aprovado':
				return 'danger'
			case 'pendente':
				return 'warning'
			case 'aprovado':
				return 'success'
		}
	}

	openEmailLog() {
		window.open(window.location.origin + '/envio-de-relatorios', '_blank')
	}

	emptyUser = {
		name: '',
		imageUrl: '',
	}

	get elaborator() {
		if (this.emailLog.is_adm) {
			return this.emailLog.group.adm[0].elaborator || this.emptyUser
		} else {
			return this.emailLog.group.elaborator || this.emptyUser
		}
	}

	get reviewer() {
		if (this.emailLog.is_adm) {
			return this.emailLog.group.adm[0].reviewer || this.emptyUser
		} else {
			return this.emailLog.group.reviewer || this.emptyUser
		}
	}

	get relation() {
		if (this.emailLog.is_adm) {
			return this.emailLog.group.adm[0].relation || this.emptyUser
		} else {
			return this.emailLog.group.relation || this.emptyUser
		}
	}
}
